var map = {
	"./Mathpaas-white.png": 8378,
	"./account_created.png": 6960,
	"./add-icon-blue.png": 1540,
	"./add-icon.png": 7607,
	"./add-profile-icon.png": 5935,
	"./arrow-back.png": 9381,
	"./arrow-next.png": 5140,
	"./assistant-icon.png": 8249,
	"./case_followup.png": 3005,
	"./case_mission.png": 9265,
	"./case_request.png": 8259,
	"./case_results.png": 4772,
	"./case_sent.png": 4483,
	"./checkmark-icon.png": 4291,
	"./comment-round.png": 3316,
	"./comments-icon.png": 678,
	"./delivery.png": 6323,
	"./dermapp-blue.png": 5038,
	"./dermapp-icon.png": 2383,
	"./dermapp-sky.png": 7285,
	"./dermapp-white.png": 9409,
	"./dermatologist_Dulce.png": 6439,
	"./dermatologist_Monica.jpeg": 8736,
	"./diagnosis-icon.png": 4644,
	"./drop-arrow.png": 6917,
	"./edit-assessment-icon.png": 6850,
	"./edit-user-icon.png": 284,
	"./exam-icon.png": 3775,
	"./exams-icon.png": 7274,
	"./exclamation.png": 6989,
	"./explanation-icon.png": 691,
	"./followup-assessment-icon.png": 893,
	"./graph-icon.png": 8552,
	"./inactive-diagnosis-icon-dark.png": 2048,
	"./inactive-diagnosis-icon.png": 4298,
	"./landing1.png": 9180,
	"./landing10.png": 1034,
	"./landing11.png": 9360,
	"./landing12.png": 9317,
	"./landing13-2.png": 9446,
	"./landing13.png": 5874,
	"./landing14.png": 494,
	"./landing15-2.png": 3900,
	"./landing15.png": 8401,
	"./landing16.png": 3560,
	"./landing2.png": 3035,
	"./landing3.png": 3129,
	"./landing4.png": 3527,
	"./landing5.png": 1672,
	"./landing6.png": 5361,
	"./landing7-2.png": 2006,
	"./landing7-3.png": 6790,
	"./landing7-4.png": 8031,
	"./landing7.png": 7857,
	"./landing8.png": 6526,
	"./landing9.png": 8672,
	"./message-icon-flat.png": 3487,
	"./message-icon.png": 6049,
	"./new-comment-flat.png": 7924,
	"./new-comment-round.png": 8960,
	"./new-message-icon-flat.png": 1218,
	"./new-message-icon.png": 4134,
	"./next-icon.png": 2857,
	"./ofertones.png": 649,
	"./payment_success.png": 9710,
	"./pencil-icon.png": 7367,
	"./plan-icon.png": 5156,
	"./previous-icon.png": 8954,
	"./profile-icon.png": 1056,
	"./prognosis-icon.png": 2187,
	"./purchase-icon.png": 1754,
	"./rate-icon.png": 1996,
	"./recommendations-icon.png": 1509,
	"./user.png": 2315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;